// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class CompetitorProduct {
  readonly id: string;
  readonly name: string;
  readonly source: string | null;
  readonly category: Enums.ProductCategory;
  readonly lastKnownPrice: string | null;
  readonly isDeletable: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.source = data.source === undefined ? null : data.source;
    this.category = data.category === undefined ? Enums.ProductCategory.ReadyMix : data.category;
    this.lastKnownPrice = data.lastKnownPrice === undefined ? null : data.lastKnownPrice;
    this.isDeletable = data.isDeletable === undefined ? false : data.isDeletable;
  }

  static zero(): CompetitorProduct {
    const zeroValues: ExcludeMethodsDeep<CompetitorProduct> = {
      id: NIL_UUID,
      name: '',
      source: null,
      category: Enums.ProductCategory.ReadyMix,
      lastKnownPrice: null,
      isDeletable: false,
    };
    return new CompetitorProduct(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type CompetitorProductWireFormat = {
  id: string;
  name: string;
  source: string | null;
  category: string;
  lastKnownPrice: string | null;
  isDeletable: boolean;
};

type NewCompetitorProductProps = PartialDeep<CompetitorProduct, { recurseIntoArrays: true }>;
export const NewCompetitorProduct: (props: NewCompetitorProductProps) => CompetitorProduct = (
  props,
) => new CompetitorProduct(props);

type NewCompetitorProductFromWireFormatProps = PartialDeep<
  CompetitorProductWireFormat,
  { recurseIntoArrays: true }
>;
export const NewCompetitorProductFromWireFormat: (
  props: NewCompetitorProductFromWireFormatProps,
) => CompetitorProduct = (props) => new CompetitorProduct(props);
